import React, { FC } from 'react';
import { TwButton, TwButtonType } from '../../../components/TwButtons/TwButtons';
import TwDialog from '../../../components/TwDialog/TwDialog';
import { ReactComponent as WarningSign } from '../../../assets/warning-sign.svg';
import { Typography, Box, styled } from '@mui/material';

interface DeleteTripConfirmationProps {
  open: boolean;
  onClose: () => void;
  onDelete: () => void;
}

export const Message = styled(Typography)({
  fontFamily: 'Poppins',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: '14px',
  lineHeight: '24px',
  color: '#6B7280'
});

const DeleteTripConfirmation: FC<DeleteTripConfirmationProps> = ({ open, onClose, onDelete }) => {
  return (
    <TwDialog
      open={open}
      onClickClose={onClose}
      size="sm"
      title="Delete trip?"
      actions={[
        <TwButton
          key="2"
          fullwidth={false}
          type={TwButtonType.secondary}
          label="Cancel"
          action={onClose}
        />,
        <TwButton
          key="1"
          fullwidth={false}
          type={TwButtonType.negative}
          label="Delete"
          action={onDelete}
        />
      ]}
      fullWidthAction
    >
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        sx={{ paddingTop: '20px' }}
      >
        <WarningSign />
        <Box paddingTop={'20px'}>
          <Message paragraph>
            You are about to delete a trip. All the trip information will be lost. This action
            cannot be undone.
          </Message>
          <Message paragraph>Are you sure you want to delete a trip?</Message>
        </Box>
      </Box>
    </TwDialog>
  );
};

export default DeleteTripConfirmation;
